import TopUpStatusMessage from './TopUpStatusMessage';
import { FormattedCurrency } from '@iwIntlProvider/FormattedCurrency';
import { useStateKey } from '../../../../../iwQueryClient/useStateKey';
import { useQuery } from '@tanstack/react-query';
import { getAccountsQueryConfig } from '@api/lendingAPI/queryConfigs';

export const NotYetTopUpEligible = ({ accountId }: { accountId: string }) => {
    const stateKey = useStateKey();

    const {
        data: accountsResponse,
        isLoading,
        isError
    } = useQuery(getAccountsQueryConfig(stateKey));

    if (isLoading || isError) return null;

    const account = accountsResponse.data!.accounts.find(
        (account) => account.account_id === accountId
    )!;
    const amountToRepayBeforeTopUp =
        account.topup_eligibility!.amount_to_repay_before_topup;

    return (
        <TopUpStatusMessage
            heading={
                <>
                    You can request more funds once you've repaid{' '}
                    <FormattedCurrency value={amountToRepayBeforeTopUp} />
                </>
            }
            description="You've passed our eligibility checks but your approval will still be subject to a credit review"
            ctaText="Get in touch"
        />
    );
};
